import React from 'react';
import {useSelector} from 'react-redux';
import CatalogNavItem from './CatalogNavItem';
import CatalogSort from './CatalogSort';

const CatalogNav = () => {
	const {nav} = useSelector((state) => state.catalog);

	return (
		<nav className="catalog__nav mt-5">
			<div className="catalog__nav-links">
				{
					nav.map((item) => <CatalogNavItem key={item.id} navItem={item}/>)
				}
			</div>
			<CatalogSort />
		</nav>
	);
};

export default CatalogNav;
